import { useHttp } from '@publicisgroupe/p-os-components';
import { useEffect } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { LOGIN_CALLBACK_ROUTE_KEY } from 'utils/constants';
import { ROUTE_ROOT } from 'utils/routes';

export const LoginCallback = () => {
  const history = useHistory();
  const http = useHttp();

  const route = localStorage.getItem(LOGIN_CALLBACK_ROUTE_KEY);

  useEffect(() => {
    http?.post('/navigation/invalidatecache').catch(console.error);
  }, [history, http, route]);

  return <Redirect to={route ?? ROUTE_ROOT} />;
};
